import axios from "../axiosInstance";
import {
  UnshareResourceFromEmployeesParams,
  UnshareResourceFromEmployeesResponse,
} from "./types";

export const unshareResourceFromEmployees = async (
  params: UnshareResourceFromEmployeesParams,
): Promise<UnshareResourceFromEmployeesResponse> => {
  const response = await axios.post<UnshareResourceFromEmployeesResponse>(
    `/api/private/resources/${params.resourceUuid}/unshare`,
    { employeeUuids: params.employeeUuids },
  );
  return response.data;
};
